import axios from "axios";
import { InstitutionId, config, IdentificationTypes, GetPatientInfo, GetEpisodes, GetUriUploadPhoto, PutPatient, PatientEpisode, AllPatient, PutPatientWithInternmentAndEpisode, GetEstablishments, GetInternments, PatientInternment } from "../../../utils/constants";


export function getPatientsManagementSearch(searchData) {
    var language = localStorage.getItem("i18nextLng") || "pt";
    if (language.length > 2) {
        language = language.substr(0, 2).toUpperCase();
    }
    else {
        language = language.toUpperCase();
    }

    //let page = searchData.Page + 1;
    //let numberOfRecords = searchData.NumberOfRecordsPerPage;
    //var url = `${config.url.API_URL}${AllPatient}?language=${language}&numberOfRecords=${numberOfRecords}&page=${page}`;

    var urlAllUsers = `${config.url.API_URL}${AllPatient}`;
    var urlIdentificationTypes = `${config.url.API_URL}${IdentificationTypes}`;

    let institution = localStorage.getItem(InstitutionId);
    var urlEstablishments = `${config.url.API_URL}${GetEstablishments}?institutionId=${institution}`;

    /*     var searchData = {
            Order: this.props.patientsManage.Order,
            PropertyOrder: this.props.patientsManage.PropertyOrder,
            NumberOfRecordsPerPage: this.props.patientsManage.NumberRowsPerPage,
            Page: this.props.patientsManage.Page
        } */


    var values = {
        language: language,
        numberOfRecords: searchData.NumberOfRecordsPerPage,
        page: searchData.Page + 1,
        Order: searchData.Order,
        Property: searchData.PropertyOrder,
    };


    return dispatch => {
        Promise.all([
            axios.post(urlAllUsers, values),
            axios.get(urlIdentificationTypes),
            axios.get(urlEstablishments)
        ])
            .then(([resp, respTypes, respEst]) => {
                dispatch([
                    {
                        type: "PATIENTS_MANAGEMENT_SEARCH",
                        payload: resp,
                        identificationTypes: respTypes,
                        establishments: respEst,
                        error: false
                    }
                ]);
            })
            .catch(e => {
                dispatch([
                    {
                        type: "PATIENTS_MANAGEMENT_SEARCH",
                        payload: e.response,
                        error: true,
                        searchData: searchData
                    }
                ]);
            });
    };
}

export function getPatientInfoManagement(patientID) {
    var language = localStorage.getItem("i18nextLng") || "pt";
    if (language.length > 2) {
        language = language.substr(0, 2).toUpperCase();
    }
    else {
        language = language.toUpperCase();
    }

    var urlPatient = `${config.url.API_URL}${GetPatientInfo}?id=${patientID}&language=${language}`;
    var urlEpisodes = `${config.url.API_URL}${GetEpisodes}?PatientId=${patientID}`;
    var urlInternments = `${config.url.API_URL}${GetInternments}?PatientId=${patientID}`;

    return dispatch => {
        Promise.all([
            axios.get(urlPatient),
            axios.get(urlEpisodes),
            axios.get(urlInternments)
        ])
            .then(([respPatient, respEpisodes, respIntern]) => {
                dispatch([
                    {
                        type: "PATIENT_INFO_MANAGEMENT",
                        payload: respPatient,
                        episodes: respEpisodes,
                        internments: respIntern,
                        error: false
                    }
                ]);
            })
            .catch(e => {
                dispatch([
                    {
                        type: "PATIENT_INFO_MANAGEMENT",
                        payload: e.response,
                        error: true
                    }
                ]);
            });
    };
}

export function getURItoUploadPhotoPatient(namephoto) {
    const url = `${config.url.API_URL}${GetUriUploadPhoto}?photoName=${namephoto}`;

    return dispatch => {
        axios
            .get(url)
            .then(resp => {
                dispatch({
                    type: "URIPHOTOPATIENT_VALIDATED",
                    payload: resp.data.result,
                    error: false
                });
            })
            .catch(e =>
                dispatch({ type: "URIPHOTOPATIENT_VALIDATED", payload: e.response, error: true })
            );
    };
}

export function createPatient(values) {
    const url = `${config.url.API_URL}${PutPatient}`;

    return dispatch => {
        axios
            .post(url, values)
            .then(resp => {
                dispatch({
                    type: "CREATEPATIENT_VALIDATED",
                    payload: resp.data.result,
                    error: false
                });
            })
            .catch(e =>
                dispatch({ type: "CREATEPATIENT_VALIDATED", payload: e.response, error: true })
            );
    };
}

export function updatePatient(values) {
    const url = `${config.url.API_URL}${PutPatientWithInternmentAndEpisode}`;

    return dispatch => {
        axios
            .put(url, values)
            .then(resp => {
                dispatch({
                    type: "UPDATEPATIENT_VALIDATED",
                    payload: resp.data.result,
                    error: false
                });
            })
            .catch(e =>
                dispatch({ type: "UPDATEPATIENT_VALIDATED", payload: e.response, error: true })
            );
    };
}

export function deletePatient(patientID) {
    const url = `${config.url.API_URL}${PutPatient}?id=${patientID}`;

    return dispatch => {
        axios
            .delete(url)
            .then(resp => {
                dispatch({
                    type: "DELETEPATIENT_VALIDATED",
                    payload: resp.data.result,
                    error: false
                });
            })
            .catch(e =>
                dispatch({ type: "DELETEPATIENT_VALIDATED", payload: e.response, error: true })
            );
    };
}

// TODO
export function deleteEpisode(episodeId) {
    const url = `${config.url.API_URL}${PatientEpisode}?id=${episodeId}`;

    return dispatch => {
        axios
            .delete(url)
            .then(resp => {
                dispatch({
                    type: "DELETEEPISODE_VALIDATED",
                    payload: resp.data.result,
                    error: false
                });
            })
            .catch(e =>
                dispatch({ type: "DELETEEPISODE_VALIDATED", payload: e.response, error: true })
            );
    };
}

//TODO
export function deleteEpisodeAndInternment(episodeId, internmentId) {
    const urlEp = `${config.url.API_URL}${PatientEpisode}?id=${episodeId}`;
    const urlInt = `${config.url.API_URL}${PatientInternment}?id=${internmentId}`;

    return dispatch => {
        axios.delete(urlEp)
            .then(function (response) {

                axios.delete(urlInt)
                    .then(resp => {
                        dispatch({
                            type: "DELETEEPISODE_VALIDATED",
                            payload: resp.data.result,
                            error: false
                        });
                    })
                    .catch(e =>
                        dispatch({ type: "DELETEEPISODE_VALIDATED", payload: e.response, error: true })
                    );

            })
            .catch(e =>
                dispatch({ type: "DELETEEPISODE_VALIDATED", payload: e.response, error: true })
            );
    }

    /* return dispatch => {
        axios
            .delete(url)
            .then(resp => {
                dispatch({
                    type: "DELETEINTERNMENT_VALIDATED",
                    payload: resp.data.result,
                    error: false
                });
            })
            .catch(e =>
                dispatch({ type: "DELETEINTERNMENT_VALIDATED", payload: e.response, error: true })
            );
    }; */
}